import { createBatchQueue } from "./batchQueue";

const enqueue = createBatchQueue({ missingValue: [] }); // absent id = no journal entries

export function fetchJournalBatched(contentId, fetchBatchJournalForContent) {
  return enqueue(contentId, fetchBatchJournalForContent);
}
